import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Collapse, message, Skeleton } from "antd";
import PageContainer from "../../components/PageContainer";
import ContentSearch from "../blog/components/ContentSearch";
import withFaqWrapper from "./FaqWrapper";
import { MinusCircleFilled, PlusCircleFilled } from "@ant-design/icons";
import { getFAQService } from "./faq.api";

const { Panel } = Collapse;

const Faq = () => {
  const [loading, setLoading] = useState(false);
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    setLoading(true);
    getFAQService()
      .then((res) => {
        if (res.hasOwnProperty("data") && res.data.hasOwnProperty("content"))
          setQuestions(res.data.content);
      })
      .catch((err) => {
        console.error(err);
        message.error("خطایی در دریافت اطلاعات");
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <PageContainer
      classNames="faq"
      headerProps={{
        link: "/menu",
        right: "",
        content: "سوالات متداول",
        className: "home-header-holder transactions-header-holder",
        children: (
          <div style={{ marginTop: 40 }}>
            <ContentSearch
              showFilterForm={false}
              allowClear={true}
              inputName="title"
            />
          </div>
        ),
        tall: true,
      }}
    >
      <div className="faq-title">پرسش و پاسخ های متدوال:</div>
      <div className="faqs-wrapper">
        {loading ? (
          <>
            <Skeleton active={true} loading={loading} />
            <Skeleton active={true} loading={loading} />
            <Skeleton active={true} loading={loading} />
          </>
        ) : questions && questions.length > 0 ? (
          <Collapse
            defaultActiveKey={["1"]}
            ghost
            bordered={false}
            expandIcon={(panelProps) => {
              return panelProps.isActive ? (
                <MinusCircleFilled />
              ) : (
                <PlusCircleFilled />
              );
            }}
            className="faq-collapse"
          >
            {questions.map((questionObj, i) => {
              return (
                <Panel
                  key={i + 1}
                  header={questionObj.question}
                  className="faq-panel"
                >
                  <p className="faq-description">{questionObj.answer}</p>
                </Panel>
              );
            })}
          </Collapse>
        ) : (
          "داده‌ای وجود ندارد"
        )}
      </div>
      <NavLink to={"/support"} className="request-support" disabled={loading}>
        ثبت در خواست پشتیبانی
      </NavLink>
    </PageContainer>
  );
};

export default withFaqWrapper(Faq);
